import { useState } from "react";

/**
 * WatchImage: <img> with skeleton loader + visible error fallback.
 * If the image fails to load we surface a styled fallback that
 * shows the watch name + ref so the page never has invisible holes.
 */
export default function WatchImage({
  src,
  alt,
  fallbackTitle,
  fallbackSub,
  className = "",
  loading = "lazy",
  onClick,
  testId,
  objectFit = "contain",
}) {
  const [state, setState] = useState("loading"); // 'loading' | 'ok' | 'error'

  return (
    <div className={`relative w-full h-full ${className}`} data-testid={testId}>
      {state !== "ok" && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-full h-full flex flex-col items-center justify-center border border-[rgba(197,160,89,0.18)] bg-[#0F140E] text-center p-6 gap-3">
            {state === "loading" ? (
              <>
                <div className="w-14 h-14 border border-[#C5A059]/30 rotate-45 animate-pulse" />
                <span className="text-[10px] uppercase tracking-[0.32em] text-[#A8A9AD]">
                  Loading…
                </span>
              </>
            ) : (
              <>
                <span className="text-[10px] uppercase tracking-[0.32em] text-[#C5A059]">
                  {fallbackSub || "CLEMENT"}
                </span>
                <span className="font-serif-display text-xl text-[#F5F2EB]">
                  {fallbackTitle || alt}
                </span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#A8A9AD]/70 max-w-[16ch]">
                  Image unavailable
                </span>
              </>
            )}
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        onLoad={() => setState("ok")}
        onError={() => {
          // eslint-disable-next-line no-console
          console.warn("[CLEMENT] image failed to load:", src);
          setState("error");
        }}
        onClick={onClick}
        className={`relative w-full h-full ${
          objectFit === "cover" ? "object-cover" : "object-contain"
        } transition-opacity duration-500 ${
          state === "ok" ? "opacity-100" : "opacity-0"
        }`}
      />
    </div>
  );
}
